import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SubPaymentsPage } from '@/features/subcontracts/payments-page';

const searchSchema = z.object({
  tab: z
    .enum(['applications', 'certificates', 'invoices', 'reconciliation'])
    .optional()
    .catch(undefined),
  certificate: z.string().optional().catch(undefined),
  valuation: z.string().optional().catch(undefined),
  subcontractId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/payments')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <SubPaymentsPage
      projectId={projectId}
      tab={search.tab}
      certificate={search.certificate}
      valuation={search.valuation}
      subcontractId={search.subcontractId}
    />
  );
}
